import GenericModel from '../generic-model';
import { Project } from '../project/project';
import Company from '../company/company';
import { PriceLine } from '../price-line';

export default class ProjectInvoice extends GenericModel {
  type?: string;
  teamleaderId?: string;
  booked?: boolean;
  project?: Project;
  company?: Company;
  priceLines?: PriceLine[];
  sentDate?: Date;
  invoiceNumber?: string;
  referenceNumber?: string;
  onlyChargePriceLines?: boolean;

  // For display purposes only
  displaySubtotal?: number;
  displayProductPrice?: Map<number, ProductPriceDisplay>;
  displayBoardPartPrice?: Map<number, BoardPartPriceDisplay[]>;

  // For display only
  displayPrice?: number;

  constructor(company?: Company) {
    super();
    this.company = company;
  }
}

export interface ProductPriceDisplay {
  productTotal: string;
  prices: PriceWithReason[];
}

export interface BoardPartPriceDisplay {
  title: string;
  subtitles: string[];
  price: string;
}

export interface PriceWithReason {
  price: string;
  reason: string;
}
